export default __webpack_public_path__ + "static/media/fork.40f07892.svg";